import { render, staticRenderFns } from "./ImportPropertyWizardMandatoryDataForm.vue?vue&type=template&id=5bc48240&scoped=true&"
import script from "./ImportPropertyWizardMandatoryDataForm.vue?vue&type=script&lang=js&"
export * from "./ImportPropertyWizardMandatoryDataForm.vue?vue&type=script&lang=js&"
import style0 from "./ImportPropertyWizardMandatoryDataForm.vue?vue&type=style&index=0&id=5bc48240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc48240",
  null
  
)

export default component.exports